import { createSlice } from "@reduxjs/toolkit";

export interface IModuleDroitState {
  openDialogModuleDroit: boolean;
  moduleDroits: IModuleDroit[];
  objModuleDroit: IModuleDroit;
  openEdit: boolean;
  valueModuleDroit: string;
  valueEdit: string;

}

export interface IModuleDroit {
  idModuleDroit: string;
  libModuleDroit: string;
  createdAt: string;
  updatedAt: string;
}



export const moduleDroitSlice: any = createSlice({
  name: "modulesDroit",
  initialState: {
    openDialogModuleDroit: false,
    moduleDroits: [],
    objModuleDroit: {},
    openEdit: false,
    valueModuleDroit: "",
    valueEdit: "",

  },
  reducers: {

    setOpenDialogModuleDroit: (state, action) => {
      state.openDialogModuleDroit = action.payload;
    },
    setValueEdit: (state, action) => {
      state.valueEdit = action.payload;
    },

    setOpenEdit: (state, action) => {
      state.openEdit = action.payload;
    },

    addModuleDroits: (state, action) => {
      const newModuleDroit: any = [...state.moduleDroits, action.payload]
      state.moduleDroits = newModuleDroit;
    },

    setModuleDroits: (state, action) => {
      state.moduleDroits = action.payload;
    },

    setObjModuleDroit: (state, action) => {
      state.objModuleDroit = action.payload;
    },

    deleteModuleDroit: (state, action) => {
      state.moduleDroits = state.moduleDroits.filter((m: IModuleDroit) => m.idModuleDroit !== action.payload);
    },

    editModuleDroit: (state, action) => {
      const newModuleDroit: any = state.moduleDroits.map((m: IModuleDroit) => (m.idModuleDroit === action.payload.idModuleDroit ? action.payload : m))
      state.moduleDroits = newModuleDroit;
    },

  }
});

export const { setOpenDialogModuleDroit,
  addModuleDroits,
  setModuleDroits,
  setObjModuleDroit,
  deleteModuleDroit,
  editModuleDroit,
  setOpenEdit,
  setValueEdit
} = moduleDroitSlice.actions;


export default moduleDroitSlice.reducer;
